import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
    alpha,
    useMediaQuery
} from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export type SidebarProps = {
    items: SidebarItem[];
    title?: string;
}

export type SidebarItem = {
    text: string;
    icon: React.ReactNode;
    path: string;
    exact?: boolean;
    onClick?: () => void;
} | "divider"

const Sidebar = ({ items, title }: SidebarProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isSelected = (path: string, exact = false) => {
        if (!path.startsWith("/")) {
            path = "/" + path;
        }
        return location.pathname === path || (!exact && location.pathname.startsWith(path));
    }

    const isMobile = useMediaQuery('(max-width: 600px)');

    return (
        <Box
            sx={{
                width: isMobile ? 60 : 240,
                bgcolor: 'background.paper',
                borderRight: '1px solid rgba(75, 85, 99, 0.12)',
                height: '100%',
                overflow: 'auto',
            }}
        >
            <Stack display={title && !isMobile ? "flex" : "none"} pt={3} pb={1} gap={3}>
                <Typography variant="h6" component="h1" sx={{ fontWeight: 'bold', px: 2, cursor: 'pointer' }} onClick={() => navigate('/admin')}>
                    {title}
                </Typography>
                <Divider />
            </Stack>

            <List component="nav" >
                {items.map((item, index) => {
                    if (item === "divider") {
                        return <Divider key={index} />
                    }

                    return (
                        <ListItem key={index} disablePadding >
                            <ListItemButton
                                onClick={() => navigate(item.path)}
                                selected={isSelected(item.path, item.exact)}
                                sx={{
                                    borderRadius: 0,
                                    '&.Mui-selected': {
                                        backgroundColor: theme => alpha(theme.palette.primary.main, 0.1),
                                        color: 'text.primary',
                                        '&:hover': {
                                            backgroundColor: theme => alpha(theme.palette.primary.main, 0.3),
                                        },
                                    }
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 40,
                                        color: theme => isSelected(item.path, item.exact) ? theme.palette.primary.main : theme.palette.text.secondary
                                    }}>
                                    {item.icon}
                                </ListItemIcon>
                                <Stack width={1} display={isMobile ? 'none' : 'block'}>
                                    <ListItemText
                                        primary={item.text}
                                        sx={{
                                            "& span": {
                                                color: theme => isSelected(item.path, item.exact) ?
                                                    theme.palette.primary.main :
                                                    theme.palette.text.primary
                                            }
                                        }}

                                    />
                                </Stack>
                            </ListItemButton>
                        </ListItem>
                    )
                })}
            </List>
        </Box>
    );
};

export default Sidebar;
